import request from '@/router/axios'

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'true' ? '/wage' : '/wage'

// 已发放的薪资明细表
export function selectDataForSalaryDetail(data) {
  return request({
    url: urlPrefix + '/salaryHistory/selectDataForSalaryDetail',
    method: 'post',
    data
  })
}


// 预览工资单-邮件
export function previewpayslipemail(data) {
  return request({
    url: urlPrefix + '/wagebatchinfo/previewpayslipemail',
    method: 'post',
    data
  })
}

// 预览工资单-手机端
export function previewpayslipphone(data) {
  return request({
    url: urlPrefix + '/wagebatchinfo/previewpayslipphone',
    method: 'post',
    data
  })
}

// 预览为发放的工资的工资单-手机端
export function previewUnPaySlipPhone(data) {
  return request({
    url: urlPrefix + '/wagebatchinfo/previewUnPaySlipPhone',
    method: 'post',
    data
  })
}


// 未发放批次信息
export function selectUnPayBatchInfo(data) {
  return request({
    url: urlPrefix + '/salaryHistory/selectUnPayBatchInfo',
    method: 'post',
    data
  })
}

// 员工未完成发放的
export function selectUnpayDataForSalaryDetail(data) {
  return request({
    url: urlPrefix + '/salaryHistory/selectUnpayDataForSalaryDetail',
    method: 'post',
    data
  })
}

// 创建批量下载任务
export function createTask(data) {
  return request({
    url: urlPrefix + '/payslip/createTask',
    method: 'post',
    data
  })
}

// 刷新下载任务列表
export function reflashData(data) {
  return request({
    url: urlPrefix + '/payslip/reflashData',
    method: 'post',
    data
  })
}

// 单个下载pdf文件
export function downloadPdf(data) {
  return request({
    url: urlPrefix + '/payslip/downloadPdf',
    method: 'post',
    data
  })
}

// 刷新下载任务列表
export function getSysProofIncomeTemp(data) {
  return request({
    url: urlPrefix + '/payslip/getSysProofIncomeTemp',
    method: 'post',
    data
  })
}

// 保存收入证明的前后描述
export function saveSysProofIncomeTemp(data) {
  return request({
    url: urlPrefix + '/payslip/saveSysProofIncomeTemp',
    method: 'post',
    data
  })
}

// 生成word版本收入证明-合并
export function downloadWordProofAllInOne(data) {
  return request({
    url: urlPrefix + '/payslip/downloadWordProofAllInOne',
    method: 'post',
    data
  })
}

// 生成word版本收入证明-每人一个
export function downloadWordProof(data) {
  return request({
    url: urlPrefix + '/payslip/downloadWordProof',
    method: 'post',
    data
  })
}

// 生成pdf版本收入证明-合并
export function downloadPdfProofAllInOne(data) {
  return request({
    url: urlPrefix + '/payslip/downloadPdfProofAllInOne',
    method: 'post',
    data
  })
}

// 生成pdf版本收入证明-每人一个
export function downloadPdfProof(data) {
  return request({
    url: urlPrefix + '/payslip/downloadPdfProof',
    method: 'post',
    data
  })
}
